var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/stream-browserify/~/isarray/index.js
// module id = 1303
// module chunks = 0